var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 79,
    viewBox: "-10 -10 89 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.4328H53.7578V11.6964H0.5V18.4328ZM63.441 0.629395C60.767 0.629395 58.5994 2.78368 58.5994 5.44112V24.688C58.5994 27.3455 60.767 29.4998 63.441 29.4998C66.1149 29.4998 68.2826 27.3455 68.2826 24.688V5.44112C68.2826 2.78368 66.1149 0.629395 63.441 0.629395ZM34.3913 40.5667V34.3115C34.3913 31.654 32.2236 29.4998 29.5497 29.4998C26.8757 29.4998 24.7081 31.654 24.7081 34.3115V53.5584C24.7081 56.2159 26.8757 58.3701 29.5497 58.3701C32.2236 58.3701 34.3913 56.2159 34.3913 53.5584V47.3032H68.2826V40.5667H34.3913ZM0.5 47.3032H19.8665V40.5667H0.5V47.3032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9067f0654b6f2d2617533b1b9103c700.svg";
export { ForwardRef as ReactComponent };